import Refresher from "./table/refresher";
import LayoutSwitcher from "./table/layout-switcher";
import { initAdminColumnsGlobalBootstrap } from "AC/helpers/admin-columns";
import { EventConstants } from "AC/constants";
var AdminColumns = initAdminColumnsGlobalBootstrap();
AdminColumns.events.addListener(EventConstants.TABLE.READY, function (e) {
    var table = e.table;
    table.Refresher = new Refresher(table);
    var switcher = document.querySelector('.layout-switcher');
    if (switcher) {
        var layout_switcher = new LayoutSwitcher(switcher);
        layout_switcher.place();
    }
});
